<template>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
      :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{title}}</div>
      </div>
      <span><i style="margin-right:10px;" class="el-icon-warning"></i>{{text}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="beSure">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props:{
        title:{
            type:String,
            default:'确认框'
        },
        text:String,
        // rules:Object,
        dialogVisible:Boolean
    },
    watch:{
      dialogVisible:{
       deep: true,
       handler(v) {
          this.dialogVisible = v
       }
      }
    },
    data(){
        return {
          
        }
    },
    methods:{
        ...mapActions(["setDialogFormVisible"]),
        handleClose(){
          this.$emit('handleClose')
        },

        beSure(){
          this.$emit('beSure')
        },
        changeX(e){
          // console.log(e)
          this.$forceUpdate()
        }
    },
    created(){
      
    }
}
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
</style>